var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "xmlns=\"http://www.w3.org/2000/svg",
    className: "wt-icon--inverted ecl-icon ecl-icon--m ecl-link__icon ecl-social-media-follow__icon ecl-icon-networks--facebook",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46 24.134C46 11.911 36.15 2 24 2S2 11.91 2 24.134C2 35.182 10.045 44.34 20.563 46V30.532h-5.586v-6.398h5.585v-4.876c0-5.548 3.285-8.612 8.31-8.612 2.407 0 4.925.432 4.925.432v5.448h-2.775c-2.732 0-3.584 1.705-3.584 3.457v4.151h6.1l-.973 6.398h-5.127V46C37.954 44.339 46 35.182 46 24.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m32.756 30.539.984-6.287h-6.16v-4.079c0-1.72.862-3.396 3.62-3.396H34v-5.353S31.458 11 29.028 11c-5.073 0-8.39 3.01-8.39 8.461v4.791H15v6.287h5.639v15.197c1.131.174 2.29.264 3.47.264 1.182 0 2.34-.09 3.47-.264V30.54h5.177Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1dea450f172d1c7fa18dafa8545d93ec.svg";
export { ForwardRef as ReactComponent };